import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import responsiveSize from 'helper/responsiveSize'

interface IInputProps {
  empty?: boolean
  error?: string
  secondary?: boolean
}

interface IStyleProps {
  rounded?: boolean
  small?: boolean
  medium?: boolean
  large?: boolean
  icon?: boolean
  error?: string
  disabled?: boolean
}

export const Span = styled.span`
  position: absolute;
  left: 11px;
  top: -13px;

  color: ${(props: IInputProps) =>
    props.secondary ? Theme.pallete.PRIMARY4 : Theme.pallete.QUATERNARY};
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  height: 20;

  padding: 2px 10px;
  border-radius: 10px;

  background: ${(props: IInputProps) =>
    props.secondary ? Theme.pallete.SECONDARY : Theme.pallete.PRIMARY};

  opacity: ${(props: IInputProps) => (props.empty ? '0' : '1')};

  @media only screen and (min-width: 1441px) {
    font-size: 13px;
    padding: 2px 14px;
  }
`

export const Input = styled.input`
  position: ${(props: IStyleProps) => (props.icon ? 'relative' : 'inherit')};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 40px;
  box-sizing: border-box;
  padding: 16px 16px 16px 16px;
  margin-left: 0.5px;
  transition: all 0.3s ease-out;
  height: 48px;
  outline: none;
  color: #424242;
  background: ${(props) =>
    props.disabled ? Theme.pallete.QUATERNARY : Theme.pallete.SECONDARY};
  border: 1px solid;
  border-color: ${(props) =>
    props.disabled
      ? Theme.pallete.QUATERNARY
      : props.error
      ? '#D61212'
      : '#cccccc'};
  &:hover {
    border-color: ${(props) =>
      props.disabled
        ? Theme.pallete.QUATERNARY
        : props.error
        ? '#B00000'
        : '#757575'};
  }
  &:disabled {
    color: rgb(84, 84, 84);
  }
  border-radius: ${(props: IStyleProps) => (props.rounded ? '30px' : '5px')};
  width: 100%;
  max-width: 100%;
`

export const Error = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: ${Theme.pallete.SENARY};
  margin-top: 10px;
`

export const InputError = styled.div`
  font-family: ${Theme.fontFamily.SECONDARY};
  position: absolute;
  bottom: -3px;
  transform: translateY(100%);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${Theme.pallete.SENARY};
`
